import { ensureTicketIds } from './ticketHelpers';

const generateMessageId = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `msg-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
};

export const makeA2UIMessage = (type, props) => ({
  type: 'updateComponents',
  surface_id: `msg-${generateMessageId()}`,
  components: [{ id: 'widget-1', type, props }],
});

const processA2UIBetTickets = (a2ui) => {
  if (!a2ui) return null;
  const component = a2ui.components[0];
  if (component?.type !== 'bet_tickets') return a2ui;

  const tickets = component.props.bet_tickets || [];
  const processedTickets = ensureTicketIds(tickets).map((ticket) => ({
    ...ticket,
    isModified: ticket.isModified ?? false,
  }));

  return {
    ...a2ui,
    components: [
      {
        ...component,
        props: { ...component.props, bet_tickets: processedTickets },
      },
    ],
  };
};

export const createUserMessage = (content) => ({
  id: generateMessageId(),
  type: 'user',
  content,
  timestamp: new Date().toISOString(),
});

export const createAssistantMessage = (content, a2ui = null) => ({
  id: generateMessageId(),
  type: 'assistant',
  content,
  timestamp: new Date().toISOString(),
  a2ui: processA2UIBetTickets(a2ui),
});

export const createErrorMessage = (errorMsg) => createAssistantMessage(errorMsg);
